export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-1200-4341fe653206a5455d24607af7c22ab2.webp";